<ng-form #form="ngForm">
    <ng-content></ng-content>
</ng-form>